var module = angular.module('octopusApp.library');

module.controller('RequirementsEditDialogController', function($scope, busy, $uibModalInstance, requirements) {
    var vm = this;
    vm.requirements = requirements;
    vm.minimumType = 'All';
    vm.minEnvironmentCount = requirements.MinimumEnvironmentsBeforePromotion;

    if(requirements.MinimumEnvironmentsBeforePromotion <= 0) {
        vm.minimumType = 'All';
        vm.minEnvironmentCount = requirements.EnvironmentCount;
    }

    if (requirements.IsOptionalPhase) {
        vm.minimumType = 'None'
    } else if (requirements.EnvironmentCount > 1 && requirements.MinimumEnvironmentsBeforePromotion > 0) {
        vm.minimumType = 'Some';
    }

    vm.close = function() {
    $uibModalInstance.close();
  };

    vm.save = function () {
      requirements.IsOptionalPhase = (vm.minimumType === 'None');
      requirements.MinimumEnvironmentsBeforePromotion = (vm.minimumType == 'Some') ? vm.minEnvironmentCount : 0;
    $uibModalInstance.close(requirements);
  };
});




//////////////////
// WEBPACK FOOTER
// ./app/areas/library/lifecycles/controllers/lifecycle_requirements_edit_dialog_controller.js
// module id = 4796399206028371
// module chunks = 1